<template>
<div class="chapter">
<div class="inner_page">
<p class="ct"><b><span style="color: #1A9540;"><span class="small">CONTENTS </span></span></b></p>
<p class="toc"><b><a href="#/Text/intro#rk1" id="vk1"><span class="small">INTRODUCTION </span></a></b></p>
<p class="toc"><b><a href="#/Text/chap01#rk2" id="vk2"><span style="color: #F58221;"><span class="small">CHAPTER ONE </span></span><br/>THANKSGIVING</a></b></p>
<p class="toc"><b><span href="#/Text/chap02#rk3" id="vk3" title="Link target outside of Sample"><span style="color: #D22339;"><span class="small">CHAPTER TWO </span></span><br/>CHRISTMAS and<br/> THE HOLIDAY SEASON</span></b></p>
<p class="toc"><b><span href="#/Text/chap03#rk4" id="vk4" title="Link target outside of Sample"><span style="color: #068ECB;"><span class="small">CHAPTER THREE </span></span><br/>JEWISH HOLIDAYS:<br/> PASSOVER, ROSH HASHANAH,<br/>and HANUKKAH</span></b></p>
<p class="toc"><b><span href="#/Text/chap04#rk5" id="vk5" title="Link target outside of Sample"><span style="color: #92528A;"><span class="small">CHAPTER FOUR </span></span><br/>EASTER</span></b></p>
<p class="toc"><b><span href="#/Text/chap05#rk6" id="vk6" title="Link target outside of Sample"><span style="color: #FFC20A;"><span class="small">CHAPTER FIVE </span></span><br/>INDEPENDENCE DAY and<br/>SUMMER ENTERTAINING</span></b></p>
<p class="toc"><b><span href="#/Text/chap06#rk7" id="vk7" title="Link target outside of Sample"><span style="color: #1A9540;"><span class="small">CHAPTER SIX </span></span><br/>BRUNCHES, APPETIZERS,<br/> and POTLUCK DISHES</span></b></p>
<p class="toc"><b><span href="#/Text/ack#rk9" id="vk9" title="Link target outside of Sample"><span class="small">ACKNOWLEDGMENTS </span></span></b></p>
<p class="toc"><b><span href="#/Text/ack#rk10" id="vk10" title="Link target outside of Sample"><span class="small">ABOUT THE AUTHOR </span></span></b></p>
<p class="serv" id="pagevi"><img alt="image" src="Images/p-5.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3668d3c3